import React from 'react';
import {ThemeProvider} from '@rneui/themed';

import rewardsTheme from '../../../theme/rewardsTheme';

import PickupDeliverComponentLoyaltyEnabled from './PickupDeliverComponentLoyaltyEnabled';

export default () => (
  <ThemeProvider theme={rewardsTheme}>
    <PickupDeliverComponentLoyaltyEnabled />
  </ThemeProvider>
);
